import type { Editor } from '@tiptap/core';

/** Returns the text the editor has selected, or "" when nothing is. */
export function getEditorSelectedText(editor: Editor): string {
  const { from, to } = editor.state.selection;
  return editor.state.doc.textBetween(from, to, ' ');
}

/**
 * Links the selection, or the whole link under the cursor, to `href`. With
 * `text`, inserts it at the cursor as a link to `href`.
 */
export function insertEditorLink(
  editor: Editor,
  { text, href }: { text?: string; href: string }
): void {
  editor.chain().focus().extendMarkRange('link').setLink({ href }).run();
  if (text !== undefined && text !== '') {
    editor.chain().focus().insertContent(text).run();
  }
}
